import React from "react";
import { Typography, Button, Grid, Link, Box, Stack } from "@mui/material";
import { stripHtml } from "./utility";
import brokenImg from "../Asset/images/broken-images.png";

export default function CardRelease(props) {
  const { id, name, description, logo_full_path, background, company_name } =
    props.data;
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "auto",
          height: {
            xs: "310px",
            lg: "250px",
          },
          position: "relative",
          borderRadius: 4,
          backgroundColor: background ? background : "#cc0600",
        }}
      >
        <Grid container style={{ padding: "30px", color: "#fff" }}>
          <Grid item xs={8} sm={8}>
            <Stack direction="column" spacing={1}>
              <Link
                href={`/detail/${id}`}
                underline="none"
                sx={{ color: "#fff" }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {name}
                </Typography>
              </Link>
              <Typography variant="body1" sx={{ paddingBottom: "10px" }}>
                {company_name || "PT Mcash Integrasi, Tbk"}
              </Typography>
              {console.log("desc:", stripHtml(description.toString()))}
              <Typography variant="body2" sx={{ paddingBottom: "10px" }}>
                {stripHtml(description).slice(0, 45)} ...
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={4} sm={4} sx={{ textAlign: "right" }}>
            <Box
              sx={{
                backgroundColor: "#fff",
                width: {
                  lg: "120px",
                  md: "120px",
                  xs: "90px",
                },
                height: {
                  lg: "120px",
                  md: "120px",
                  xs: "90px",
                },
                borderRadius: 5,
                boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                position: "relative",
              }}
            >
              <Box
                component="img"
                src={logo_full_path || brokenImg}
                alt={name}
                sx={{
                  borderRadius: 5,
                  width: {
                    lg: "100%",
                    md: "125px",
                    xs: "100%",
                  },
                  height: {
                    lg: "auto",
                    md: "125px",
                    xs: "auto",
                  },
                  position: "relative",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              position: "absolute",
              bottom: 15,
              width: "85%",
            }}
          >
            <Link href={`/detail/${id}`}>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: "20px",
                  background: "#228B22",
                }}
              >
                More
              </Button>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
}
